import {Locale} from '../../../../provider/locale/locale';
import {FieldModeEnum} from '../../../../service/company/company-type';

export const TAG_TEXT_BY_MODE: Record<FieldModeEnum, JSX.Element> = {
    [FieldModeEnum.addition]: <Locale stringKey="BULK_EDIT_COMPANIES__CONFIRM_FIELDS_FIELD_MODE__ADDITION" />,
    [FieldModeEnum.replacement]: <Locale stringKey="BULK_EDIT_COMPANIES__CONFIRM_FIELDS_FIELD_MODE__REPLACEMENT" />,
};

export const CONFIRM_MODAL_WIDTH = 480;
